<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">特集コピー</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">企画回</label>
            <div class="list-input-content">
              <input type="text" readonly id="lbl_CatalogId" #lbl_CatalogId [style.width.px]="112"
                [(ngModel)]="kymw4502Model.delivCatalogId" />
            </div>
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <input type="text" readonly id="lbl_OrderCode" #lbl_OrderCode [style.width.px]="112"
                [(ngModel)]="kymw4502Model.orderCode" />
            </div>
            <label class="list-input-title">コピー元企画回</label>
            <div class="list-input-content">
              <app-catalog-text-with-order #txti_CatalogId [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="kymw4502Model.copiedCatalogId" width="112"
                (onChangedOrderCode)="kymw4502Model.copiedOrderCode= $event" (ngModelChange)="eventBlurHandler_CatalogId()">
              </app-catalog-text-with-order>
            </div>
            <label class="list-input-title">コピー元受注コード</label>
            <div class="list-input-content">
              <app-order-text-with-catalog id="txti_OrderCode" #txti_OrderCode [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="kymw4502Model.copiedOrderCode" width="112"
                (onChangedCatalogId)="kymw4502Model.copiedCatalogId= $event" (ngModelChange)="eventBlurHandler_OrderCode()">
              </app-order-text-with-catalog>
            </div>
          </div>
          <button id="btn_Display" #btn_Display class="btn-secondary" [tabindex]="0"
            (click)="eventClickHandler_Display()" forcedEnabledMode="true">表示</button>
          <wj-flex-grid #dtg_MediumTypeList id="dtg_MediumTypeList" [allowDragging]="'None'"
            [tabindex]="0" [allowSorting]="false" rowHeight="25" [itemsSource]="kymw4502Model.mediumTypeList"
            [isReadOnly]="true" [headersVisibility]="'Column'" resizableColumns="false" [selectionMode]="'Row'">
            <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'checked'" [header]="' '"
              [isReadOnly]="true">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="checkbox" [(ngModel)]="cell.item.checked" [tabindex]="-1" id="selected_{{cell.row.index}}"
                  [disabled]="!cell.item.copiable" (mouseup)="$event.stopPropagation()" />
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="467" [binding]="'mediumName'" [header]="'媒体'">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Out" [tabindex]="0" class="btn-primary"
            (click)="eventClickHandler_Decide(null)">決定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>